/* global angular */

(function() {
    "use strict";

    var app = angular.module('app');

    app.controller('ContactUsCtrl', ['$scope', '$controller', 'State', 'api', 'gtm', function ($scope, $controller, State, api, gtm) {

        $controller('FormCtrl', {
            $scope: $scope
        });

        var state = new State();
        var model = {};
        var data = {};
        
        api.data.contact().then(function (response) {
            $scope.data = data = response.data;            
            state.ready();

        }, function (error) {
            state.error(error);

        });

        function submit() {
            if (state.busy()) {
                if (model.birthdate) {
                    model.birthdate = new Date(Date.UTC(model.birthdate.getFullYear(), model.birthdate.getMonth(), model.birthdate.getDate(), model.birthdate.getHours()));
                }
                api.action.contact(model).then(function (response) {                
                    if (response.data.status) {
                        state.success();
                        gtm.push({
                            event: 'Contattaci'
                        });

                    } else {
                        state.error({
                            message: response.data.HTML
                        });
                    }
                }, function (error) {
                    state.error(error);

                });
            }
        }

        $scope.state = state;
        $scope.model = model;
        $scope.data = data;
        $scope.submit = submit;
        
    }]);

}());